export default {
  municipios: [],
  estadosFiltereds: [],
  municipiosFiltereds: [],
  isLoading: false,
  error: false,
  latestClicked: {}
};
